import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TabState, tabFeatureKey } from './tab.reducer';


export const selectTabState = createFeatureSelector<TabState>(tabFeatureKey);

export const selectTabs = createSelector(
    selectTabState,
    (state: TabState) => state.tabs
);